import { render, staticRenderFns } from "./ModalHistoryStatus.vue?vue&type=template&id=3ac61dd6&lang=pug&"
import script from "./ModalHistoryStatus.vue?vue&type=script&lang=js&"
export * from "./ModalHistoryStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports